import React from 'react'
import { Navigate } from 'react-router-dom'
import { useAuth } from '../../hooks/useAuth'

export const TypeUser = () => {
  const auth = useAuth()
  if (auth.user) {
    if (auth.user.typeUser === 'administrador') {
      return <Navigate to="/dashboard"/>
    } else if (auth.user.typeUser === 'organizador') {
      return <Navigate to="/mi-cuenta" />
    } else if (auth.user.typeUser === 'espectador') {
      return <Navigate to="/eventos" />
    }
  }
}
